module.exports = __webpack_public_path__ + "media/images/articles/icon_instagram_gray-98b3ab21296084b90bf927f828ad28e7.svg";